module.exports = __webpack_public_path__ + "img/Proliferation-CRC_GSE225857.458a8ccc.png";